import { useState } from "react";

export function usePreviousValue<T>(value: T) {
  const [current, setCurrent] = useState(value);
  const [previous, setPrevious] = useState(value);

  // Yes, you are allowed to set state mid-render.
  if (value !== current) {
    setPrevious(current);
    setCurrent(value);
  }

  return previous;
}
